export default __webpack_public_path__ + "static/media/3rdPartyAccessory.f3b706a6.svg";